import { StatusBar, Style as StatusBarStyle } from "@capacitor/status-bar";
import {
  isAndroidPlatform,
  isCapacitorPlatform,
} from "@src/appV2/lib/utils/capacitor/platformUtils";
import { useEffect } from "react";

export function useRedesignStatusBarAppearance() {
  useEffect(() => {
    if (!isCapacitorPlatform() || isAndroidPlatform()) {
      return undefined;
    }

    void StatusBar.setStyle({
      style: StatusBarStyle.Light,
    });

    return () => {
      void StatusBar.setStyle({
        style: StatusBarStyle.Dark,
      });
    };
  }, []);
}
